import React, { Fragment } from 'react';
import { useFromStore } from '../../utils/createStore';
import TableColumnControl from './TableColumnControl';
import getTableCellsTillBreak from '../utils/getTableCellsTillBreak';

function TableColumn(_ref) {
  var cell = _ref.cell,
      resizingWidth = _ref.resizingWidth,
      ignoreWidth = _ref.ignoreWidth;
  var style = React.useMemo(function () {
    return {
      width: !ignoreWidth ? resizingWidth || cell.getIn(['data', 'width']) : undefined
    };
  }, [cell, ignoreWidth, resizingWidth]);
  return React.createElement("col", {
    key: cell.key,
    style: style
  });
}

var FIRST_COLUMN_STYLE = {
  width: 41
};
var PADDING_COLUMN_STYLE = {
  width: '100%'
};

function TableColumnControls(_ref2) {
  var tableId = _ref2.tableId,
      table = _ref2.table,
      editor = _ref2.editor,
      store = _ref2.store,
      focusedColumnIndex = _ref2.focusedColumnIndex,
      isMobile = _ref2.isMobile;

  var _ref3 = useFromStore(store, tableId) || {},
      resizingColumn = _ref3.resizingColumn,
      resizingColumnWidth = _ref3.resizingColumnWidth;

  var firstRow = React.useMemo(function () {
    return getTableCellsTillBreak(table.nodes);
  }, [table]);
  var isFullWidth = React.useMemo(function () {
    return table.getIn(['nodes', 0, 'data', 'fullWidth']);
  }, [table]);
  var sizedColumnCount = React.useMemo(function () {
    return firstRow.filter(function (c, i) {
      return typeof c.getIn(['data', 'width']) === 'number' || resizingColumn === i;
    }).size;
  }, [firstRow, resizingColumn]);
  var columnCount = firstRow.size;

  if (editor.readOnly) {
    return false;
  }

  return React.createElement(Fragment, null, React.createElement("colgroup", null, React.createElement("col", {
    style: FIRST_COLUMN_STYLE
  }), firstRow.map(function (cell, i) {
    return React.createElement(TableColumn, {
      key: cell.key,
      cell: cell,
      resizingWidth: resizingColumn === i ? resizingColumnWidth : undefined,
      ignoreWidth: isFullWidth && i === columnCount - 1
    });
  }), sizedColumnCount === columnCount && !isFullWidth && React.createElement("col", {
    style: PADDING_COLUMN_STYLE
  })), React.createElement("thead", {
    contentEditable: false
  }, React.createElement("tr", {
    className: "slite-editor-table-control-header transition",
    contentEditable: false
  }, React.createElement("th", {
    className: "zindex-huge"
  }, React.createElement("div", {
    className: "slite-editor-table-helper"
  }), React.createElement("div", {
    className: "slite-editor-table-helper"
  })), firstRow.map(function (_, i) {
    return React.createElement(TableColumnControl, {
      key: i,
      editor: editor,
      store: store,
      tableId: tableId,
      columnIndex: i,
      isFirstColumn: i === 0,
      isLastColumn: i >= columnCount - 1,
      isMobile: isMobile,
      isFocused: focusedColumnIndex === i
    });
  }))));
}

export default React.memo(TableColumnControls);